import type { InitPayload } from './types';

/**
 * GET /api/v1/init?client=X&campaign=Y
 * El backend valida el header Origin contra los allowed_domains del cliente.
 */
export async function fetchInit(
	apiUrl: string,
	clientToken: string,
	campaignToken: string
): Promise<InitPayload> {
	const url = `${apiUrl}/api/v1/init?client=${encodeURIComponent(clientToken)}&campaign=${encodeURIComponent(campaignToken)}`;

	const response = await fetch(url, {
		headers: { Accept: 'application/json' }
	});

	const body = await response.json().catch(() => null);

	if (!response.ok || !body?.success) {
		throw new Error(body?.message || `Init failed (HTTP ${response.status})`);
	}

	return body.data as InitPayload;
}
